import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/imgs/basic/logo120.png'


const _hoisted_1 = { class: "app-name" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"height":"32px"}
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "app-name-text"
}

import { computed } from 'vue';
import { useLayoutStoreHook } from '@/store/modules/layout';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutStore = useLayoutStoreHook();

const showName = computed(() => {
  return layoutStore.opened || layoutStore.layout === 'horizontal';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(showName))
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Fine Admin"))
      : _createCommentVNode("", true)
  ]))
}
}

})